import React, { MouseEventHandler, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { ModalHeader } from './partials/ModalHeader';
import styles from './Modal.module.scss';

export const Modal = ({
    title, active, className,
    onClose, children, width = 768
}: Props) => {
    return (
        <div className={classNames(styles.default, { [styles.active]: active }, className)}>
            <div className={styles.overlay} onClick={onClose} />

            <div className={styles.container} style={{ width }}>
                <ModalHeader onClose={onClose}>
                    {title}
                </ModalHeader>

                {children}
            </div>
        </div>
    );
};

type Props = PropsWithChildren<{
    width?: number | string;
    title?: string;
    active: boolean;
    className?: string;
    onClose: MouseEventHandler;
}>;